export default __webpack_public_path__ + "static/media/Ford Bush.17fc17de.png";